module.exports = __webpack_public_path__ + "static/img/5.fc710d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/eng/5.png
// module id = m1Gh
// module chunks = 0